import deLocale from 'element-ui/lib/locale/lang/de' //引入element语言包
const de = {
  posterPage: {
    title1:'Die Abonnementfunktion ist bald verfügbar!',
    title2:'Abonnement verlängert, privilegierte Upgrades!',
    title3:'Exklusive Rabatte, Erneuerung kostengünstiger',
    title4:'Erhalten Sie einen Einlösecode und Sie können sich mit dem Verkäufer beraten, der das Gerät gekauft hat',
    title5:'Priorisierte Erfahrungsfunktionen',
    function1:'Funktion Details:',
    function2:'Verlängerung der Grundleistungen (simultaner Übersetzer, Konferenzassistent, intelligenter Assistent)...',
    function3:'Mehrwert-Service-Abonnement (Offline-Übersetzung, Audio-Videoanrufe Übersetzung)...',
  },
  RedemptionCodePage: {
    RedemptionCode: 'Einlösungscode',
    ValueAddedServices: 'Mehrwertdienste',
    UpgradedExperience: 'Exklusive Mehrwertvorteile, verbesserte Erfahrung',
    OfflineTranslation: 'Offline-Übersetzung',
    NoInternet: 'Keine Notwendigkeit für Internetverbindung, sofortige Übersetzung, sicher und zuverlässig',
    GoToSubscribe: 'Abonnieren',
    AudioAndVideoCall: 'Audio-/Videoanruf',
    RealTimeCall: 'Sprachübersetzung in Echtzeit und Zugänglichkeit der Kommunikation',
    BaseService: 'Grunddienstleistungen',
    AIAssistant: 'Funktionen: Simultandolmetschen, Konferenzassistent, KI-Assistent',
    LanguagesSetting:'Spracheinstellungen',
    languages1:'Chinesisch vereinfacht',
    languages2:'Traditionelles Chinesisch',
    languages3:'Englisch',
    languages4:'Japanisch',
    languages5:'Koreanisch',
    languages6:'Russisch',
    languages7:'Spanisch',
    languages8:'Französisch',
    languages9:'Deutsch',
    languages10:'Portugiesisch',
    languages11:'Italienisch',
    languages12:'Türkisch',
    languages13:'Vietnamesisch',
    languages14:'Indonesisch',
    languages15:'Hindi',
    languages16:'Arabisch',
    languages17:'Thailändisch',
    languages18:'Persisch',
  },
  Login: {
    ToLogin: 'einloggen',
    PhoneLogin: 'Login mit Telefonnummer',
    EmailLogin: 'E-Mail-Anmeldung',
    PhonePlaceholder: 'Bitte geben Sie Ihre Telefonnummer ein',
    EmailPlaceholder: 'Enter email',
    Code: 'Prüfcode',
    and: 'und',
    BeforeText: 'Die Erstellung eines Kontos stellt Ihre Zustimmung und Compliance dar',
    UserAgreement: 'Nutzungsvereinbarung',
    privacy: 'Datenschutzerklärung',
    errorMessage: 'Fehler im Verifizierungscode',
    readTitle: 'Lesen und stimmen Sie der folgenden Vereinbarung zu',
    readBefore: 'Um die Sicherheit Ihrer persönlichen Daten zu gewährleisten, lesen Sie bitte zuerst und stimmen Sie zu.',
    cancel: 'Abbrechen',
    agree: 'Einverständnis und Fortsetzung',
    error1:'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    error2:'Bitte geben Sie die richtige Telefonnummer ein.',
    error3:'Bitte geben Sie den Verifikationscode ein',
    success:'Erfolgreich angemeldet'
  },
  OffLinePage: {
    title: 'Offline-Übersetzung',
    NoInternet: 'Keine Notwendigkeit für Internetverbindung, sofortige Übersetzung, sicher und zuverlässig',
    ServiceLife: 'Lebensdauer',
    forever: 'Dauerhafte Verwendung',
    describe: 'Anweisungen zum Abonnement',
    describeItem1: '1.Die Offline-Übersetzungsfunktion ist eine einmalige Zahlung, dauerhafte Verwendung, und die Nutzungsberechtigung folgt dem Bluetooth-Gerät. Wenn Sie das Gerät ändern, müssen Sie den Offline-Übersetzungscode erneut abonnieren.',
    describeItem2: '2. Das Abonnement des Autorisierungscodes ist nicht erstattungsfähig.',
    describeItem3: '3. Unterstützt 10 Sprachen: Chinesisch, Englisch, Deutsch, Japanisch, Koreanisch, Hindi, Thailändisch, Spanisch, Französisch, Russisch.',
    quantity: 'Menge',
    payType: 'Zahlungsmethode',
    card: 'Bankkarte',
    wx: 'WeChat',
    GooglePay: 'Google Pay',
    subscribe: 'Abonnieren',
    RMB: '¥',
    confirm:'bestätigen',
    cardNumber:'Kartennummer',
    periodOfValidity:'Gültigkeitsdauer',
    safetyCode:'Sicherheitscode',
    name:'vollständiger Name',
    yearAndMonth:'Jahr/Monat',
    message1:'Die Zahl kann nicht 0 sein.',
    popTip:'Tipps',
    popText1:'Bitte lesen Sie es sorgfältig und verstehen Sie es.',
    popText2:'Offline-Übersetzungsvereinbarung',
    popText3:'Ich habe gelesen und stimme zu',
    popText4:'Gelesen und zugestimmt',
  },
  AudioVideoPage: {
    title: 'Audio-/Videoanruf',
    RealTime: 'Sprachübersetzung in Echtzeit und Zugänglichkeit der Kommunikation',
    describe: 'Anweisungen zum Abonnement',
    describeItem1: '1.Die Übersetzungsfunktion für Audio- und Videoanrufe ist das Aufladen und Kaufen von Minuten. Die Minuten zählen ab dem Zeitpunkt, an dem der Anruf verbunden ist, und die Berechtigungen folgen dem Konto. Wenn Sie sich bei einem anderen Konto anmelden, müssen Sie erneut aufladen.',
    describeItem2: '2. Nach dem Aufladen des Kontos können verschiedene Geräte weiterhin wie gewohnt angeschlossen und gebunden werden.',
    describeItem3: '3. Die Übersetzungsfunktion für Audio- und Videoanrufe kann nach dem Aufladen nicht erstattet werden.',
    payType: 'Zahlungsmethode',
    card: 'Bankkarte',
    wx: 'WeChat',
    GooglePay: 'Google Pay',
    subscribe: 'Abonnieren',
    RMB: '¥',
    sale: 'Rabatt',
    confirm:'bestätigen',
    time1:'Sekunden',
    time2:'Minuten',
    time3:'Stunden',
    time4:'Tag',
    time5:'Monat',
    time6:'Jahr',
  },
  OffLineResult: {
    title1: 'Offline-Übersetzung',
    title2: 'Audio-/Videoanruf',
    title3: 'Grunddienstleistungen',
    success: 'Abonnement erfolgreich',
    fail: 'Abonnement fehlgeschlagen',
    stock:'Umtauschcode auf Lager',
    saveTitle: 'Speichern Sie den Einlösungscode und gehen Sie zur App, um ihn einzulösen',
    code: 'Einlösungscode',
    tip1: 'Dieser Code wird nur zum Einlösen der Offline-Übersetzungsfunktion verwendet',
    tip2: 'Dieser Code wird nur verwendet, um die Übersetzungsfunktion für Audio-/Videoanrufe einzulösen',
    tip3: 'Dieser Code wird nur zum Einlösen grundlegender Serviceverlängerungsfunktionen verwendet',
    save: 'Speichern',
    time: 'Abonnementzeit:',
    copy: 'Kopie',
    copySuccess: 'Erfolgreich kopiert',
    loading:'Laden',
    paySuccess:'Zahlung erfolgreich'
  },
  RedemptionList: {
    title: 'Mein Einlösungscode',
    view: 'Ansicht',
    time: 'Abonnementzeit:',
  },
  MyRedemption: {
    title: 'Mein Einlösungscode',
    code: 'Einlösungscode',
    time: 'Abonnementzeit:',
    copy: 'Kopie',
    tip1: 'Dieser Code wird nur zum Einlösen der Offline-Übersetzungsfunktion verwendet',
    tip2: 'Dieser Code wird nur verwendet, um die Übersetzungsfunktion für Audio-/Videoanrufe einzulösen',
    tip3: 'Dieser Code wird nur zum Einlösen grundlegender Serviceverlängerungsfunktionen verwendet',
    save: 'Speichern',
    success:"Betrieb erfolgreich"
  },
  basePage:{
    error1:'Keine Produktinformationen verfügbar',
    message1:'Bitte wählen Sie ein Produkt',
    title:'Grunddienstleistungen',
    function:'Funktionen: Simultandolmetschen, Konferenzassistent, KI-Assistent',
    describe: 'Anweisungen zum Abonnement',
    describe1:'1. Nach der Erneuerung der grundlegenden Dienstleistungen wie Simultandolmetschen und Konferenzassistent folgt die Gültigkeitsdauer der Ausrüstung. Wird die Ausrüstung ausgetauscht, muss sie erneuert werden.',
    describe2:'2. Basisleistungen können nach der Verlängerung nicht erstattet werden.',
    payType: 'Zahlungsmethode',
    card: 'Bankkarte',
    wx: 'WeChat',
    GooglePay: 'Google Pay',
    subscribe: 'Abonnieren',
    RMB: '¥',
    sale: 'Rabatt',
    month:'der Mond',
    confirm:'bestätigen',
    month1:'1 Monat',
    month2:'Ein halbes Jahr',
    month3:'1 Jahr'
  },
  ...deLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
// 导出
export default de;
